import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ListDropDownComponent } from '@src/suite/common/components/list-drop-down/list-drop-down';
import { StLiveCardItemComponent } from '@src/suite/live/components/st-live-card-item/st-live-card-item.component';

import { BaseViewOptionsComponent } from '../base-view-options.component';

@Component({
    selector: 'st-live-view-options',
    imports: [ListDropDownComponent, MatButton, MatButtonModule, MatButtonToggleModule, MatIcon, MatListModule, MatMenuModule, MatTooltipModule, StLiveCardItemComponent],
    templateUrl: './live-view-options.component.html',
    styleUrl: './live-view-options.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-live-view-options',
    },
})
export class LiveViewOptionsComponent extends BaseViewOptionsComponent {}
